import { Section } from './Section.jsx';
import { T } from '../T.jsx';

// The two buttons point at href="#" in the original markup — no destination has
// been wired for them yet. Kept as-is rather than inventing one.
export function Cta() {
  return (
    <Section>
      <section className="cta-section" id="cta">
        <div className="cta-box fade-in">
          <T k="ml_cta_heading" as="h2">Ready to Transform Your Lectures?</T>
          <T k="ml_cta_desc" as="p">
            Join educators worldwide who are using MyLecture to create engaging, AI-powered
            presentations. Get started today — it&apos;s free for individual teachers.
          </T>
          <div className="cta-buttons">
            <T k="ml_cta_start" as="a" href="#" className="btn btn-primary">Get Started Free</T>
            <T k="ml_cta_contact" as="a" href="#" className="btn btn-secondary">Contact Sales</T>
          </div>
        </div>
        <footer>
          <p>&copy; 2026 MyLecture &mdash; The Intelligent Lecture Platform</p>
        </footer>
      </section>
    </Section>
  );
}
